import { Component, inject, model, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth.service';
import { ConfigClientService, ConfigService } from '../../core/services';

interface ApiInfo {
  Version?: string;
  InformationalVersion?: string;
  version?: string;
}

@Component({
  selector: 'app-about-dialog',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AboutDialogComponent implements OnInit {
  visible = model<boolean>(false);

  protected readonly authService = inject(AuthService);
  protected readonly configService = inject(ConfigService);
  protected readonly configClientService = inject(ConfigClientService);

  protected readonly appVersion = this.configService.getAppConfig().version;
  protected readonly informationalVersion = !this.configService.getAppConfig().production
    ? 'dev'
    : 'final';
  protected readonly isDev = !this.configService.getAppConfig().production;

  protected apiSin: ApiInfo = {};
  protected apiIntegra: ApiInfo = {};
  protected licencia = '';

  ngOnInit(): void {
    try {
      this.apiSin = JSON.parse(localStorage.getItem('apiSINInfo') ?? '{}') as ApiInfo;
    } catch {
      this.apiSin = {};
    }
    try {
      this.apiIntegra = JSON.parse(localStorage.getItem('apiINTEGRAInfo') ?? '{}') as ApiInfo;
    } catch {
      this.apiIntegra = {};
    }
    this.licencia = this.configClientService.getConfig()?.licencia ?? '';
  }

  protected close(): void {
    this.visible.set(false);
  }
}
